import styled from "@emotion/styled";
import { Box } from "@mui/material";
import { FC } from "react";

const ErrorMessage = styled(Box)(
  () => `
    color: var(--zs-errorRed);
    height: 25px;
    font-size: 12px;
    `
);

type ErrorMessageProps = {
  message: string | null;
};

export const ErrorMessageBox: FC<ErrorMessageProps> = ({ message }) => {
  return <ErrorMessage>{message}</ErrorMessage>;
};
